import request from './request'

export function crossings (data) {
  return request({
    url: '/users/crossings',
    method: 'get',
    params: data
  })
}

export function crossingsExcel (data) {
  return request({
    url: '/users/crossings.xlsx',
    method: 'get',
    params: data,
    responseType: 'blob'
  })
}
